import React from 'react';

import svg from './assets/icons-16-chevron-down.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconChevronDown = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-chevron-down" />
);
